import { useMemo } from 'react';
import { appendClassName, makeBEM } from '../../../../utils';

var getClassNameByComponent = function getClassNameByComponent(_ref) {
  var component = _ref.component,
      classPrefix = _ref.classPrefix;
  var baseClassNames = makeBEM(classPrefix, component);
  return "".concat(baseClassNames).trim();
};

export var useHeaderNavigationSelectorClassName = function useHeaderNavigationSelectorClassName(classPrefix, className) {
  return useMemo(function () {
    return {
      Root: appendClassName(getClassNameByComponent({
        component: 'Root',
        classPrefix: classPrefix
      }), className),
      Wrapper: getClassNameByComponent({
        component: 'Wrapper',
        classPrefix: classPrefix
      }),
      SelectedOptions: getClassNameByComponent({
        component: 'SelectedOptions',
        classPrefix: classPrefix
      }),
      SelectedOptionsContainer: getClassNameByComponent({
        component: 'SelectedOptionsContainer',
        classPrefix: classPrefix
      }),
      SelectedOptionsValues: getClassNameByComponent({
        component: 'SelectedOptionsValues',
        classPrefix: classPrefix
      }),
      SelectedOptionsExpansionIndicatorContainer: getClassNameByComponent({
        component: 'SelectedOptionsExpansionIndicatorContainer',
        classPrefix: classPrefix
      }),
      SelectedOptionsExpansionIndicator: getClassNameByComponent({
        component: 'SelectedOptionsExpansionIndicator',
        classPrefix: classPrefix
      }),
      OptionListContainer: getClassNameByComponent({
        component: 'OptionListContainer',
        classPrefix: classPrefix
      }),
      OptionListWrapper: getClassNameByComponent({
        component: 'OptionListWrapper',
        classPrefix: classPrefix
      }),
      OptionList: getClassNameByComponent({
        component: 'OptionList',
        classPrefix: classPrefix
      })
    };
  }, [classPrefix, className]);
};